import { createBrowserHistory } from 'history';

export type HistoryState = {
  from?: string;
  hasInvalidToken?: boolean;
};

export const history = createBrowserHistory<HistoryState>();
